import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import {Asset} from '../domain/item';

@Injectable()
export abstract class ItemSummaryItemService {

  data = {
    asset: new Asset()
  };

  public assetServiceCallback: Subject<Asset> = new Subject<Asset>();
  public assetSubject: Subject<Asset> = new Subject<Asset>();

  protected constructor() {
  }

  abstract getAsset(assetId: number): void;

  abstract saveAssetInformation(asset: Asset): Observable<any>;

  abstract saveAssetSaleInfo(asset: Asset): Observable<any>;

  abstract saveAssetBudget(assetId: number, rnrBudget: number, haulingBudget: number): Observable<any>;

  abstract reconsignAsset(equipId: number, contractId: number): Observable<any>;

  abstract resellAbandonedEquip(equipId: number): Observable<any>;

  abstract resellNotSoldAssets(contractId: number, assets: Asset[]): Observable<any>;

  abstract duplicateSerialNumber(serialNumber: string, itemId: number, assetPackageId?: number): Observable<any>;

  abstract duplicateSellerTracking(sellerTrackingCode: string,  itemId: number, assetPackageId?: number): Observable<any>;

  abstract getAssetPhoto(itemId: number): Observable<any>;
  abstract markAsReviewed(equipIds: number[]): Observable<any>;

  abstract isCheckListChanged(equipId: number,assetTypeId: number): Observable<any>;
}

